import React from "react";
import PropTypes from "prop-types";
import SummaryItem from "../components/SummaryItem.jsx";
import SectionItem from "../components/SectionItem.jsx";
import AudioFile from "../components/AudioFile.jsx";
import { ServiceLink } from "../components/ServiceLink.jsx";
import { Voicemail } from "../components/Voicemail.jsx";
import * as CONST from "../constants";

const Queue = (props) => {
  const { module } = props;
  return (
    <SummaryItem itemKey={"Queue: "}>
      <SectionItem wrapped itemKey={"Pre-connection Message"}>
        <AudioFile audioId={module.initialAudio} />
      </SectionItem>
      <SectionItem wrapped itemKey={"Waiting Music"}>
        {CONST.MusicType[module.musicTypeId]}
      </SectionItem>
      <SectionItem wrapped itemKey={"Comfort Message"}>
        <AudioFile audioId={module.comfortAudio} />
      </SectionItem>
      <SectionItem wrapped itemKey={"Interval Between Msgs"}>
        {CONST.IntervalTime[module.intervalTime]}
      </SectionItem>
      <SectionItem wrapped itemKey={"Play Position in Queue"}>
        {module.isPosition ? "Yes" : "No"}
      </SectionItem>
      {module.isPosition && (
        <SectionItem wrapped itemKey={"Position Audio"}>
          {module.positionAudioTypeId === 2 ? "Male" : "Female"}
        </SectionItem>
      )}
      <SectionItem wrapped itemKey={"Max Number In Queue"}>
        {module.maxSize === 0 ? "1" : module.maxSize}
      </SectionItem>
      <SectionItem wrapped itemKey={"Maximum Queue Time"}>
        {CONST.MaxQueueTime[module.maxQueueTime]}
      </SectionItem>

      <SectionItem wrapped itemKey="Divert Overflow to">
        {CONST.QueueDivertType[module.overflowDivertTypeId]}
      </SectionItem>
      {module.overflowDivertTypeId === 3 && (
        <SectionItem wrapped itemKey="Overflow Number">
          {module.overflowDestination}
        </SectionItem>
      )}
      {module.overflowDivertTypeId === 2 && (
        <SectionItem wrapped itemKey="Overflow Audio">
          <AudioFile audioId={module.overflowAudio} />
        </SectionItem>
      )}
      {module.overflowDivertTypeId === 4 && (
        <SectionItem wrapped itemKey="Overflow Service">
          <ServiceLink service={module.overflowModuleGroup} />
        </SectionItem>
      )}
      {module.overflowDivertTypeId === 5 && (
        <Voicemail config={module.overflowVoicemail} />
      )}

      <SectionItem wrapped itemKey={"Breakout"}>
        {module.isBreakout ? "Yes" : "No"}
      </SectionItem>
      {module.isBreakout && (
        <span>
          <SectionItem wrapped itemKey={"DTMF Digit"}>
            {CONST.DTMFKey[module.breakoutDtmfKeyId]}
          </SectionItem>
          <SectionItem wrapped itemKey="Divert Breakout to">
            {CONST.QueueDivertType[module.breakoutDivertTypeId]}
          </SectionItem>
          {module.breakoutDivertTypeId === 3 && (
            <SectionItem wrapped itemKey="Breakout Number">
              {module.breakoutDestination}
            </SectionItem>
          )}
          {module.breakoutDivertTypeId === 2 && (
            <SectionItem wrapped itemKey="Breakout Audio">
              <AudioFile audioId={module.breakoutAudio} />
            </SectionItem>
          )}
          {module.breakoutDivertTypeId === 4 && (
            <SectionItem wrapped itemKey="Breakout Service">
              <ServiceLink service={module.breakoutModuleGroup} />
            </SectionItem>
          )}
          {module.breakoutDivertTypeId === 5 && (
            <Voicemail config={module.breakoutVoicemail} />
          )}
        </span>
      )}
    </SummaryItem>
  );
};

export default Queue;

Queue.propTypes = {
  module: PropTypes.object,
  sites: PropTypes.array,
  clientId: PropTypes.any,
};
